import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LoadingScreenComponent } from './shared/components/loading-screen/loading-screen.component';
import { NavbarComponent } from './shared/components/navbar/navbar.component';

@Component({
  selector: 'vx-root',
  standalone: true,
  imports: [RouterOutlet, LoadingScreenComponent, NavbarComponent],
  template: `
    <vx-loading-screen [visible]="loading()" />
    <vx-navbar />
    <main>
      <router-outlet />
    </main>
  `
})
export class AppComponent {
  protected readonly loading = signal(true);

  constructor() {
    window.setTimeout(() => this.loading.set(false), 900);
  }
}
